"use strict";


import CurrencyFormatter from "currency-formatter";

export default class UtilFormatter {

  static setFormatValue(value = 0) {
    return CurrencyFormatter.format(value, {
      code: "BRL",
      precision: 4
    });
  }
  
  static setUnformatValue(value = "") {
    if (value)
      return parseFloat(
        CurrencyFormatter.unformat(value, {
          code: "BRL"
        })
      );

    return "R$ 0,0000";
  }

  // padrão dd/mm/yyyy
  static formatDateBR(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }
  //de isoDate para data dd/mm/yyyy
  static formatDateISOToBR(date) {
    if (!date) return null
    
    const [year, month, day] = date.substring(0,10).split('-')
    return `${day}/${month}/${year}`
  

  }
  // padrão yyyy-mm-dd
  static formatDateUS(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${year}-${month}-${day}`
  }


} // class



// WEBPACK FOOTER //
// ./src/utils/UtilFormatter.js